import React, { useEffect, useState } from "react";

export default function CurrencyForm({ initialData, onSubmit }) {
  const [form, setForm] = useState({
    code: "",
    symbol: "",
    title: "",
    status: "active",
  });

  useEffect(() => {
    if (initialData) {
      setForm({
        code: initialData.code || "",
        symbol: initialData.symbol || "",
        title: initialData.title || "",
        status: initialData.status || "active",
      });
    }
  }, [initialData]);

  const submit = (e) => {
    e.preventDefault();

    onSubmit({
      code: form.code.toUpperCase(),
      symbol: form.symbol,
      title: form.title,
      status: form.status,
    });
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      <div>
        <label className="mb-1 block text-sm font-medium">
          Currency Code<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2 uppercase"
          placeholder="USD"
          value={form.code}
          onChange={(e) =>
            setForm({ ...form, code: e.target.value })
          }
          required
        />
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium">
          Symbol<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2"
          placeholder="$"
          value={form.symbol}
          onChange={(e) =>
            setForm({ ...form, symbol: e.target.value })
          }
          required
        />
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium">
          Title<span className="text-red-500">*</span>
        </label>
        <input
          className="w-full rounded border p-2"
          placeholder="US Dollar"
          value={form.title}
          onChange={(e) =>
            setForm({ ...form, title: e.target.value })
          }
          required
        />
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium">
          Status
        </label>
        <select
          className="w-full rounded border p-2"
          value={form.status}
          onChange={(e) =>
            setForm({ ...form, status: e.target.value })
          }
        >
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      <button className="w-full rounded bg-blue-600 py-2 text-white">
        {initialData ? "Update Currency" : "Save Currency"}
      </button>
    </form>
  );
}
